<template>
    <div
        class="overflow-hidden rounded-md bb-component-background shadow-sm divide-y"
    >
        <div class="p-3 pb-0">
            <h2
                v-if="data.heading || data.template_heading"
                class="bb-component-heading"
            >
                {{ data.heading || data.template_heading }}
            </h2>
        </div>

        <ul role="list" class="divide-y bb-component-content bb-hide-top-border px-3">
            <li :key="i" v-for="(article, i) in data.items" >
                <div
                    @click="showIndex = i"
                    :class="{ show: showIndex === i }"
                    class="cursor-pointer"
                >
                    <div class="bb-component-subheading pt-3">
                        {{ article.question }}
                    </div>
                    <div class="answer mb-2">
                        <div class=" bb-component-content mt-3">
                            {{ article.answer }}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Collection",
    props: ["data"],
    data() {
        return {
            showIndex: null
        };
    }
};
</script>
<style>
.answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
}
.show .answer {
    max-height: 500px;
    transition: max-height 0.77s ease-in;
}
.bb-hide-top-border {
    border-top: none;
}
</style>
